import { createSlice } from "@reduxjs/toolkit";

const geneListSlice = createSlice({
    name : "gene",
    initialState:{

        list: []
    },
    reducers:{
        creategenenamelist (state, action){
            // console.log(action)
            // state.list.push([...state, action.payload])
            state.list =  action.payload
            // console.log(` Inside the store ${state.list}`)
        }
    }

})

export const geneListActions = geneListSlice.actions
export default geneListSlice